module.exports = __webpack_public_path__ + "static/media/cimo_logo.aa9dbbc8.svg";